import React from "react";
export default function GuestCallSettings() {
  return <details className="border border-border rounded-xl p-4" data-testid="guest-call-settings">
    <summary className="cursor-pointer font-medium">Supervisor settings · repeat-call policy</summary>
    <p className="text-sm mt-3">An unresolved steward or housekeeping call stays as one request until the crew completes or cancels it. Every repeat press sends a new crew reminder and increases the press count. Time alone does not start a separate active call.</p>
    <p className="text-xs text-muted-foreground mt-2">After completion or cancellation, the next press creates a fresh request with its count starting at one. Different guests and call types remain independent.</p>
  </details>;
}
